'use strict';

/* ========================================================
 * 		jQuery
 *
 * If you need jQuery in a JS file add this to the top of that file:
 * 		var $ = require('jquery');
 * If some JS code MUST have jQuery globally accessible then
 * add the following line inside this file (index.js).
 * 		var $ = window.jQuery = require('jquery');
 ========================================================= */

/* ========================================================
 * 		Requires
 ========================================================= */

// NOTE: This is necessary as ConstantContact otherwise injects an ancient
// version of jQuery into the head... -SB (5/1/2017)
window.$ = window.jQuery = require('jquery');

// Polyfills
require('./polyfills/requestAnimationFrame.js');
require('./polyfills/assign.js');

// Lib
document.addEventListener('jsfAjaxEvent', function(event) {
	var data = event.detail;
	var fireType = data.fireType;
	window.$(event.target).trigger('jsfAjax' + fireType.charAt(0).toUpperCase() + fireType.substring(1), data);
});

// Components
require('./lib/Forms.js').init();
require('./site/MainMenu.js').init();
require('./site/Gallery.js').init();
require('./site/Masthead.js').init();
require('./site/CertifiedPartners.js').init();
require('./site/expandContent.js').init();
var vimeoGAJS = require('./lib/vimeo.ga.js');
vimeoGAJS.init();
var youtubeGAJS = require('./lib/youtube.ga.js');
youtubeGAJS.init();

function onYouTubeIframeAPIReady() {
	//console.log('youtubeReady');
}

//require('./site/ResponsiveTables.js').init();
var Lightbox = require('./site/Lightbox.js')
Lightbox.videoInit();
Lightbox.videoRegexInit({
	anchors: document.querySelectorAll('main a:not(.gallery__image)') // Gallery videos are now supposed to be embedded in gallery__view instead of opening in lightboxes
});
var Accordion = require('./site/Accordion.js');
var ScrollTo = require('./site/ScrollTo.js');

require('./site/LanguageSelectionForm.js').init();

/* ========================================================
 * 		Component Setup
 ========================================================= */

// Accordions
var baseAccordion = new Accordion({
	component: 'accordionItem',
	trigger: 'accordionItem__heading',
	active: 'accordionItem--active'
});
baseAccordion.activate();

var nestedAccordion = new Accordion({
	component: 'accordionGroup--nested',
	trigger: 'accordionGroup__heading',
	active: 'accordionGroup--active'
});
nestedAccordion.activate();

//
var eventScrollTo = new ScrollTo({
	triggerClass: 'events__link'
});
eventScrollTo.activate();

//
window.generatePushableURL = function() {
	var res = location.toString().replace(location.search, '');
	var isFirst = true;
	if ($('select.selectedCategory').val() !== '- All Categories -') {
		res = res + '?category=' + $('select.selectedCategory').val();
		isFirst = false;
	}
	if ($('select.selectedYear').val() !== '- All Years -') {
		res = res + (isFirst ? '?' : '&') + 'year=' + $('select.selectedYear').val();
		isFirst = false;
	}
	return res;
}

// Constant Contact Form
var constantContactForm = $('div[data-form-id="3805885e-b97a-4541-ba1b-41e7b44d4343"]');
if (constantContactForm){
	var checkForSuccessMessage = (function(){
		var intervalID = window.setInterval(function(){
			var successMessage = constantContactForm.find('div[data-qe-id="success-message"]');
			if (successMessage.length) {
				window.clearInterval(intervalID);

				var observer = new MutationObserver(function(mutations) {
					mutations.forEach(function(mutationRecord) {
						var analytics = Analytics.getInstance();
						analytics.trackEvent('Newsletter Signup', 'Visible', 'Success Message', undefined, false);
					});
				});

				var target = successMessage.get(0);
				observer.observe(target, { attributes : true, attributeFilter : ['style'] });
			}
		}, 500);
		window.setTimeout(function(){
			window.clearInterval(intervalID);
		}, 3000);
	})();
}

require('./site/ExitIntent.js').init();

require('./site/howCanWeHelp.js').init();

require('./site/Tabs.js').init();

require('./site/AnchorLinkSmoothScroll.js').init();

// require('./site/PublicCategoryFilter.js').init();
